import Icon from '../../components/Icon.vue'

Icon.register({"brands/bandcamp":{"width":496,"height":512,"paths":[{"d":"M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM296.2 334.1H115.2L199.9 178H380.9L296.2 334.1z"}]}})



// WEBPACK FOOTER //
// ./node_modules/vue-awesome/icons/brands/bandcamp.js